import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Products from "./pages/Products";
import CategoryPage from "./pages/CategoryPage";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import BlogPage from "./pages/BlogPage";
import BlogDetails from "./pages/BlogDetails";

import Login from "./components/login";
import Signup from "./components/Signup";
import ForgotPassword from "./components/ForgotPassword";
import EmailVerification from "./components/EmailVerification";

import PopularProducts from "./pages/PopularProducts";
import ProductDetails from "./components/ProductDetails";
import CartPage from "./pages/CartPage";
import Sidebar from "./components/Sidebar";
import TrackOrder from "./pages/TrackOrder";
import CheckoutPage from "./pages/CheckoutPage";

function App() {
  // ✅ Login status check
  const isAuth = !!localStorage.getItem("token");

  return (
    <>
      <ScrollToTop />
      <Header />

      <Routes>
        {/* 🔹 PUBLIC ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/category" element={<CategoryPage />} />
        <Route path="/eyeglasses" element={<CategoryPage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/blogs" element={<BlogPage />} />
        <Route path="/blogs/:slug" element={<BlogDetails />} />
        <Route path="/popular-products" element={<PopularProducts />} />
        <Route path="/product/:id" element={<ProductDetails />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/track-order" element={<TrackOrder />} />
        <Route
          path="/auth/email-verification/:token"
          element={<EmailVerification />}
        />

        {/* 🔹 AUTH ROUTES (Login hone par redirect) */}
        <Route
          path="/login"
          element={isAuth ? <Navigate to="/" replace /> : <Login />}
        />
        <Route
          path="/signup"
          element={isAuth ? <Navigate to="/" replace /> : <Signup />}
        />
        <Route
          path="/forgot-password"
          element={isAuth ? <Navigate to="/" replace /> : <ForgotPassword />}
        />

        {/* 🔹 PROTECTED ROUTES (Login required) */}
        <Route
          path="/profile"
          element={isAuth ? <Sidebar /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/checkout"
          element={isAuth ? <CheckoutPage /> : <Navigate to="/login" replace />}
        />

        {/* 🔹 FALLBACK */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer />
      <ToastContainer />
    </>
  );
}

export default App;
